import { render, staticRenderFns } from "./PageRecommendRecord.vue?vue&type=template&id=7620effc&scoped=true"
import script from "./PageRecommendRecord.vue?vue&type=script&lang=js"
export * from "./PageRecommendRecord.vue?vue&type=script&lang=js"
import style0 from "./PageRecommendRecord.vue?vue&type=style&index=0&id=7620effc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7620effc",
  null
  
)

export default component.exports